import React, {Suspense, lazy} from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import HomePage from 'pages/landing';
import { NavigationUtil } from 'utils/NavigationUtil';
import { PageLoader } from 'components/molecules/pageLoader';
import ProductDetails from 'pages/productDetails';
const About = lazy(() => import('pages/about'));
const ArchitectureDesign = lazy(() => import('pages/architectureDesign'));
const Careers = lazy(() => import('pages/careers'));
const CareerDetails = lazy(() => import('pages/careerDetails'));
const Contact = lazy(() => import('pages/contact'));
const Events = lazy(() => import('pages/events'));
const EventDetails = lazy(() => import('pages/eventDetails'));
const OurHomes = lazy(() => import('pages/homes'));
const NotFound = lazy(() => import('pages/notFound'));
const Privacy = lazy(() => import('pages/privacy'));
const ProjectDetails = lazy(() => import('pages/projectDetails'));
const Rentals = lazy(() => import('pages/rentals'));
const RentalDetails = lazy(() => import('pages/rentalDetails'));
const Resorts = lazy(() => import('pages/resorts'));
const OurRestaurants = lazy(() => import('pages/restaurants'));
const DiningDetails = lazy(() => import('pages/restaurantDetails'));
const CraftBeerPage = lazy(() => import('pages/craftBeerBrewery'));
const Stores = lazy(() => import('pages/stores'));
const Terms = lazy(() => import('pages/terms'));
const Workspaces = lazy(() => import('pages/workspaces'));
const CampaignPage = lazy(() => import('pages/campaign'));
const PropertyManagement = lazy(() => import('pages/propertyManagement'));
const LoyaltyProgram = lazy(() => import('pages/loyaltyProgram'));
const ThinkDesign = lazy(() => import('pages/thinkDesign'));
const WorkspaceDetails = lazy(() => import('pages/workspaceDetails'));
const ThankYou = lazy(() => import('pages/thankYou'));
const CompletedProjectRentals = lazy(() => import('pages/completedProjectRentals'));
const PaymentConfirmation = lazy(() => import('pages/paymentConfirmation'));
const PaymentCancellation = lazy(() => import('pages/paymentCancellation'));
const PastEventsPage = lazy(() => import('pages/pastEvents'));
const landCraft = lazy(() => import('pages/landCraft'));
const landCraftDetails = lazy(() => import('pages/landCraftDetails'));
const workspaceProductDetails = lazy(() => import('pages/workspaceProductDetails'));
const TermsAndConditions = lazy(() => import('pages/terms&conditions'));


export const RouteNames = {
  landing: '/',
  homes: '/homes',
  projectDetails: '/:projectSlug',
  productDetails: '/homes/:productSlug',
  restaurants: '/restaurants',
  restaurantDetails: '/restaurants/:restaurantSlug/:outletSlug',
  careers: '/careers',
  careerDetails: '/careers/:careerSlug',
  about: '/about',
  store: '/store',
  rentals: '/rentals',
  thankYou: '/thank-you',
  rentalDetails: '/rentals/:projectSlug/:productSlug/:rentalSlug',
  workcations: '/workcations',
  workcationsDetails: '/workcations/:workspaceSlug',
  workcationsProductDetails: '/workcations/product/:productSlug',
  resorts: '/resorts',
  musicEvents: '/music-and-events',
  pastMusicEvents: '/past-music-and-events',
  eventDetails: '/music-and-events/:eventSlug',
  architectureDesign: '/architecture-and-design',
  craftBeerBrewery: '/craftbeer-and-brewery',
  contact: '/contact',
  //TODO : add 'blog' route name.
  blog: '',
  terms: '/disclaimer',
  privacy: '/privacy-policy',
  notFound: '/not-found',
  campaign: '/campaign/:campaignSlug',
  property: '/property-management',
  loyaltyProgram: '/loyalty-program',
  thinkDesign: '/think-design',
  completedProjectRentals: '/rentals/:rentalSlug',
  paymentConfirmation: '/confirmation',
  paymentCancellation: '/cancelled',
  landCraft: '/Land-Craft',
  landCraftDetails: '/Land-Craft/:projectSlug',
  conditions: '/terms-and-conditions',
};

export default function RouteComponent() {
  const checkForUrl = props => {
    let isPathExist = false;
    const path = NavigationUtil.getVerticalKeyForLocation(props.location);
    for (let key in RouteNames) {
      if (key !== 'projectDetails' && key !== 'landing') {
        let routePath = RouteNames[key].split('/', 2);
        if (path !== routePath[1]) {
          isPathExist = false;
        } else {
          isPathExist = true;
          return <NotFound />;
        }
      }
    }
    if (!isPathExist) {
      return <ProjectDetails {...props} />;
    }
  };
  const isMobile = useMediaQuery({ query: '(max-device-width: 560px)' });

  return (
    <Suspense fallback={<PageLoader isMobile={isMobile} />}>
      <Router>
        <Switch>
          <Route exact path={RouteNames.landing} component={HomePage} />
          <Route exact path={RouteNames.campaign} component={CampaignPage} />
          <Route exact path={RouteNames.homes} component={OurHomes} />
          <Route
            exact
            path={RouteNames.productDetails}
            component={ProductDetails}
          />
          <Route exact path={RouteNames.restaurants} component={OurRestaurants} />
          <Route
            exact
            path={RouteNames.restaurantDetails}
            component={DiningDetails}
          />
          <Route exact path={RouteNames.careers} component={Careers} />
          <Route
            exact
            path={RouteNames.careerDetails}
            component={CareerDetails}
          />
          <Route exact path={RouteNames.about} component={About} />
          <Route exact path={RouteNames.rentals} component={Rentals} />
          <Route
            exact
            path={RouteNames.rentalDetails}
            component={RentalDetails}
          />
          <Route exact path={RouteNames.musicEvents} component={Events} />
          <Route exact path={RouteNames.eventDetails} component={EventDetails} />
          <Route exact path={RouteNames.pastMusicEvents} component={PastEventsPage} />
          <Route
            exact
            path={RouteNames.architectureDesign}
            component={ArchitectureDesign}
          />
          <Route
            exact
            path={RouteNames.craftBeerBrewery}
            component={CraftBeerPage}
          />
          <Route exact path={RouteNames.contact} component={Contact} />
          <Route exact path={RouteNames.terms} component={Terms} />
          <Route exact path={RouteNames.privacy} component={Privacy} />
          <Route
            exact
            path={RouteNames.conditions}
            component={TermsAndConditions}
          />
          <Route
            exact
            path={RouteNames.property}
            component={PropertyManagement}
          />
          <Route
            exact
            path={RouteNames.loyaltyProgram}
            component={LoyaltyProgram}
          />
          <Route exact path={RouteNames.thinkDesign} component={ThinkDesign} />
          <Route exact path={RouteNames.resorts} component={Resorts} />
          <Route exact path={RouteNames.store} component={Stores} />
          <Route exact path={RouteNames.workcations} component={Workspaces} />
          <Route exact path={RouteNames.thankYou} component={ThankYou} />
          <Route exact path={RouteNames.landCraft} component={landCraft} />
          <Route
            exact
            path={RouteNames.landCraftDetails}
            component={landCraftDetails}
          />
          <Route
            exact
            path={RouteNames.paymentConfirmation}
            component={PaymentConfirmation}
          />
          <Route
            exact
            path={RouteNames.paymentCancellation}
            component={PaymentCancellation}
          />
          <Route
            exact
            path={RouteNames.workcationsDetails}
            component={WorkspaceDetails}
          />
          <Route
            exact
            path={RouteNames.workcationsProductDetails}
            component={workspaceProductDetails}
          />
          <Route
            exact
            path={RouteNames.projectDetails}
            render={props => checkForUrl(props)}
          />
          <Route
            exact
            path={RouteNames.completedProjectRentals}
            component={CompletedProjectRentals}
          />
          <Route exact path={RouteNames.notFound} component={NotFound} />
          <Redirect to={RouteNames.notFound} />
        </Switch>
      </Router>
    </Suspense>
  );
}
